import React from 'react';
import {
  ShipmentBanner,
  ShipmentCost,
  ShipmentUnits
} from 'src/components/ShipmentBanner';
import { OfferStatusBadge } from 'src/components/StatusBadge';
import emptyImg from 'src/images/empty.svg';
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Icon,
  Link,
  ListGroup,
  ListGroupItem,
  Row,
  ScreenSize,
  Table,
  TableBody,
  TableData,
  TableHead,
  TableHeader,
  TableRow
} from 'straightline-ui';
import { formatMoney } from 'straightline-utils/accounting';
import { OFFER_STATUS } from 'straightline-utils/constants';
import { formatDate } from 'straightline-utils/time';

const Loader = ({ error }) => {
  const loaderLength = [1, 2, 3, 4, 5];
  return (
    <React.Fragment>
      <ScreenSize xs sm>
        {() => (
          <Card className="mx-n3">
            {error && (
              <div
                className="d-flex align-items-center justify-content-center rounded position-absolute h-100 w-100"
                style={{ backgroundColor: 'rgba(237, 242, 249, 0.5)' }}
              >
                <div className="lead text-danger">{error.message}</div>
              </div>
            )}
            <ListGroup>
              {!error &&
                loaderLength.map((item, index) => {
                  return (
                    <ListGroupItem key={index}>
                      <Row className="justify-content-between">
                        <Col xs="auto">
                          <div
                            className="bg-light rounded"
                            style={{ height: 33, width: 100 }}
                          />
                        </Col>
                        <Col xs="auto">
                          <div className="text-secondary d-flex align-items-center">
                            <div
                              className="bg-light rounded"
                              style={{ height: 14, width: 30 }}
                            />
                            <div className="text-muted"> &#9679; </div>
                            <div
                              className="bg-light rounded"
                              style={{ height: 14, width: 40 }}
                            />
                          </div>
                          <div className="text-secondary d-flex align-items-center">
                            <div
                              className="bg-light rounded"
                              style={{ height: 14, width: 40 }}
                            />
                            <div className="text-muted"> &#9679; </div>
                            <div
                              className="bg-light rounded"
                              style={{ height: 14, width: 30 }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <ListGroup className="list-group list-group-flush list-group-activity my-3">
                        <ListGroupItem className="py-3">
                          <Row>
                            <Col xs="auto" className="bg-white text-secondary">
                              <div
                                className="bg-light rounded"
                                style={{ height: 14, width: 50 }}
                              />
                            </Col>
                          </Row>
                        </ListGroupItem>

                        <ListGroupItem className="py-3">
                          <Row>
                            <Col xs="auto">
                              <div className="avatar avatar-sm">
                                <div className="avatar-title font-size-lg rounded-circle bg-light text-dark">
                                  <Icon type="truck" />
                                </div>
                              </div>
                            </Col>
                            <Col className="ml-n2">
                              <div>
                                <div
                                  className="bg-light rounded mb-2"
                                  style={{ height: 18, width: 90 }}
                                />
                                <div>
                                  <div
                                    className="bg-light rounded"
                                    style={{ height: 16, width: 170 }}
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </ListGroupItem>
                        <ListGroupItem className="py-3">
                          <Row>
                            <Col xs="auto">
                              <div className="avatar avatar-sm">
                                <div className="avatar-title font-size-lg rounded-circle bg-light text-dark">
                                  <Icon type="map-pin" />
                                </div>
                              </div>
                            </Col>
                            <Col className="ml-n2">
                              <div>
                                <div
                                  className="bg-light rounded mb-2"
                                  style={{ height: 18, width: 170 }}
                                />
                                <div
                                  className="bg-light rounded"
                                  style={{ height: 18, width: 170 }}
                                />
                              </div>
                            </Col>
                          </Row>
                        </ListGroupItem>
                      </ListGroup>

                      <div
                        className="bg-light rounded"
                        style={{ height: 18, width: 170 }}
                      />
                    </ListGroupItem>
                  );
                })}
            </ListGroup>
          </Card>
        )}
      </ScreenSize>
      <ScreenSize md lg xl>
        {() => (
          <Card>
            <div className="table-responsive">
              <Table className="table table-nowrap card-table">
                <TableHead>
                  <TableRow>
                    <TableHeader className="px-3 px-xl-4">Status</TableHeader>
                    <TableHeader className="px-3 px-xl-4">Pickup</TableHeader>
                    <TableHeader className="px-3 px-xl-4">Delivery</TableHeader>
                    <TableHeader className="px-3 px-xl-4">Service</TableHeader>
                    <TableHeader className="px-3 px-xl-4">Details</TableHeader>
                  </TableRow>
                </TableHead>
                <TableBody className="list">
                  {loaderLength.map((item, index) => (
                    <TableRow style={{ height: 79 }} key={index}>
                      <TableData className="px-4" style={{ width: '1%' }}>
                        <div
                          className="bg-light rounded mb-2"
                          style={{ height: 18, width: 120 }}
                        />
                        <div
                          className="bg-light rounded"
                          style={{ height: 18, width: 105 }}
                        />
                      </TableData>
                      <TableData className="px-4" style={{ width: '1%' }}>
                        <div
                          className="bg-light rounded mb-2"
                          style={{ height: 18, width: 95 }}
                        />
                        <div
                          className="bg-light rounded"
                          style={{ height: 18, width: 89 }}
                        />
                      </TableData>
                      <TableData
                        className="px-4"
                        style={{ width: '1%', position: 'relative' }}
                      >
                        <div
                          style={{ position: 'absolute', left: -12, top: 21 }}
                        >
                          <Icon
                            type="arrow-right text-light font-weight-bold"
                            style={{ fontSize: 25 }}
                          />
                        </div>
                        <div
                          className="bg-light rounded mb-2"
                          style={{ height: 18, width: 95 }}
                        />
                        <div
                          className="bg-light rounded"
                          style={{ height: 18, width: 89 }}
                        />
                      </TableData>
                      <TableData className="px-4" style={{ width: '1%' }}>
                        <div
                          className="bg-light rounded mb-2"
                          style={{ height: 18, width: 42 }}
                        />
                        <div
                          className="bg-light rounded"
                          style={{ height: 18, width: 32 }}
                        />
                      </TableData>
                      <TableData className="px-4">
                        <div
                          className="bg-light rounded mb-2"
                          style={{ height: 18, width: 60 }}
                        />
                        <div
                          className="bg-light rounded"
                          style={{ height: 18, width: 170 }}
                        />
                      </TableData>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
            {error && (
              <div
                className="d-flex align-items-center justify-content-center rounded position-absolute h-100 w-100"
                style={{ backgroundColor: 'rgba(237, 242, 249, 0.5)' }}
              >
                <div className="lead text-danger">{error.message}</div>
              </div>
            )}
          </Card>
        )}
      </ScreenSize>
    </React.Fragment>
  );
};

export function ShipmentOffersList({ offers }) {
  const { result, isLoading, isError, error, isPreviousData } = offers;

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <Loader error={error} />;
  }

  if (result.total === 0) {
    return (
      <Card>
        <CardBody style={{ minHeight: 390 }}>
          <Row className="align-items-center ">
            <Col md="6" className="text-center mb-4 mb-md-0">
              <div className="p-5">
                <img
                  src={emptyImg}
                  alt="No Loads"
                  className="img-fluid mb-4 mb-xl-0 animated fadeIn faster"
                />
              </div>
            </Col>
            <Col md="6">
              <h1>No Active Offers</h1>
              <p className="mb-4 text-muted lead">
                You don't have any active offers at the moment. Check the Load
                Board to find new loads and make offers.
              </p>
              <Row className="mb-n3">
                <Col sm="12" md="auto" className="mb-3">
                  <Button to="/shipment-matches" color="primary" block>
                    <Icon type="clipboard" className="mr-2" />
                    View Load Board
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }

  return (
    <React.Fragment>
      <ScreenSize xs sm>
        {() => <MatchesListMobile result={result} />}
      </ScreenSize>
      <ScreenSize md lg xl>
        {() => (
          <MatchesListDesktop result={result} isPreviousData={isPreviousData} />
        )}
      </ScreenSize>
    </React.Fragment>
  );
}

function MatchesListDesktop({ isPreviousData, result, queryState }) {
  return (
    <Card className={isPreviousData ? 'is-fetching' : ''}>
      <div className="table-responsive">
        <Table className="table table-nowrap card-table table-hover">
          <TableHead>
            <TableRow>
              <TableHeader className="px-3 px-xl-4">Payout</TableHeader>
              <TableHeader className="px-3 px-xl-4">Pickup</TableHeader>
              <TableHeader className="px-3 px-xl-4">Delivery</TableHeader>
              <TableHeader className="px-3 px-xl-4">Service</TableHeader>
              <TableHeader className="px-3 px-xl-4">Details</TableHeader>
              <TableHeader className="px-3 px-xl-4">Status</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody className="list">
            {result.data.map((offer) => {
              const shipment = offer.shipment;
              return (
                <TableRow
                  key={offer.id}
                  to={`/shipment-matches/${shipment.id}`}
                >
                  <TableData className="px-3 px-xl-4" style={{ width: '1%' }}>
                    <div className="d-flex">
                      <del
                        className="h1 mb-0 text-primary mr-3"
                        style={{ lineHeight: 1, opacity: 0.65 }}
                      >
                        {formatMoney(shipment.rate.price.carrier_price, {
                          precision: 0
                        })}
                      </del>
                      <div
                        className="h1 mb-0 text-primary"
                        style={{ lineHeight: 1 }}
                      >
                        {formatMoney(offer.offer_amount, {
                          precision: 0
                        })}
                      </div>
                    </div>
                  </TableData>
                  <TableData className="px-3 px-xl-4" style={{ width: '1%' }}>
                    <p className="mb-0">
                      {shipment.pickup_address.city},{' '}
                      {shipment.pickup_address.state}
                    </p>
                    <p className="mb-0">
                      {formatDate(shipment.pickup_date, 'LLL d, yyyy')}
                    </p>
                  </TableData>
                  <TableData
                    className="px-3 px-xl-4"
                    style={{ width: '1%', position: 'relative' }}
                  >
                    <div style={{ position: 'absolute', left: -12, top: 21 }}>
                      <Icon
                        type="arrow-right text-success"
                        style={{ fontSize: 25 }}
                      />
                    </div>
                    <p className="mb-0">
                      {shipment.delivery_address.city},{' '}
                      {shipment.delivery_address.state}
                    </p>
                    <p className="mb-0">
                      {formatDate(shipment.due_date, 'LLL d, yyyy')}
                    </p>
                  </TableData>
                  <TableData>
                    <div>{shipment.rate.service_level.name}</div>
                    <ShipmentCost shipment={shipment} />
                  </TableData>
                  <TableData>
                    <ShipmentUnits shipment={shipment} />
                  </TableData>
                  <TableData>
                    {(() => {
                      if (offer.status === OFFER_STATUS.PENDING) {
                        return (
                          <Badge
                            color="soft-warning"
                            style={{ padding: 8.5, fontSize: '95%' }}
                          >
                            Pending
                          </Badge>
                        );
                      }

                      if (offer.status === OFFER_STATUS.REJECTED) {
                        return (
                          <Badge
                            color="soft-danger"
                            style={{ padding: 8.5, fontSize: '95%' }}
                          >
                            Rejected
                          </Badge>
                        );
                      }

                      if (offer.status === OFFER_STATUS.ACCEPTED) {
                        return (
                          <Badge
                            color="soft-success"
                            style={{ padding: 8.5, fontSize: '95%' }}
                          >
                            Accepted
                          </Badge>
                        );
                      }

                      return (
                        <Badge
                          color="soft-info"
                          style={{ padding: 8.5, fontSize: '95%' }}
                        >
                          Countered
                        </Badge>
                      );
                    })()}
                  </TableData>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
}

function MatchesListMobile({ result, queryState }) {
  return (
    <Card className="mx-n3">
      <ListGroup>
        {result.data.map((offer) => {
          const shipment = offer.shipment;

          return (
            <ListGroupItem
              key={offer.id}
              tag={Link}
              to={`/shipment-matches/${shipment.id}`}
              className="list-group-item-action px-3"
            >
              <ShipmentBanner shipment={shipment} />
              <ListGroup className="list-group list-group-flush list-group-activity my-3">
                {shipment.pickup_distance ? (
                  <ListGroupItem className="py-3">
                    <Row>
                      <Col xs="auto" className="bg-white text-secondary">
                        {shipment.pickup_distance} mi
                      </Col>
                      <Col className="ml-n2 text-secondary">deadhead</Col>
                    </Row>
                  </ListGroupItem>
                ) : null}
                <ListGroupItem className="py-3">
                  <Row>
                    <Col xs="auto">
                      <div className="avatar avatar-sm">
                        <div className="avatar-title font-size-lg rounded-circle bg-light text-dark">
                          <Icon type="truck" />
                        </div>
                      </div>
                    </Col>
                    <Col className="ml-n2">
                      <div>
                        <div className="font-weight-bold">
                          {`${shipment.pickup_address.city}, ${shipment.pickup_address.state}`}
                        </div>
                        <div>
                          {formatDate(shipment.pickup_date, 'LLL d, yyyy')}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </ListGroupItem>
                <ListGroupItem className="py-3">
                  <Row>
                    <Col xs="auto">
                      <div className="avatar avatar-sm">
                        <div className="avatar-title font-size-lg rounded-circle bg-light text-dark">
                          <Icon type="map-pin" />
                        </div>
                      </div>
                    </Col>
                    <Col className="ml-n2">
                      <div>
                        <div className="font-weight-bold">
                          {`${shipment.delivery_address.city}, ${shipment.delivery_address.state}`}
                        </div>
                        <div>
                          {formatDate(shipment.due_date, 'LLL d, yyyy')}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </ListGroupItem>
              </ListGroup>

              <div>
                Your offer of {formatMoney(offer.offer_amount)} is{' '}
                <OfferStatusBadge status={offer.status} />
              </div>
            </ListGroupItem>
          );
        })}
        {/* <ListGroupItem>
          <TablePaginationBtns
            total={result.total}
            limit={5}
            skip={queryState.getInState('query.$skip', 0)}
            setSkip={($skip) => queryState.setInState('query.$skip', $skip)}
          />
        </ListGroupItem> */}
      </ListGroup>
    </Card>
  );
}
